import { render, staticRenderFns } from "./LunboImgs.vue?vue&type=template&id=53141708&scoped=true&"
import script from "./LunboImgs.vue?vue&type=script&lang=js&"
export * from "./LunboImgs.vue?vue&type=script&lang=js&"
import style0 from "./LunboImgs.vue?vue&type=style&index=0&id=53141708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53141708",
  null
  
)

export default component.exports